import {useState} from "react";
import store from "../../core/providers";
import {loginSuccess} from "../../core/providers/auth/reducers";
import toast from "react-hot-toast";
import {useNavigate} from "react-router-dom";
import AuthService from "./Service";

const Login = () => {
    const navigate = useNavigate();
    const [service] = useState(new AuthService());
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        let data = { username, password };
        const res = await service.login(data);
        if (res) {
            store.dispatch({
                type: loginSuccess,
                payload: res
            });
            toast.success("Login successful.");
            navigate("/");
        }
    }

  return (
      <div className={'page-sign'}>
          <div className="card card-sign">
              <div className="card-header">
                  <a href="#" className="header-logo mb-4">ERRATIC</a>
                  <h3 className="card-title">Sign In</h3>
                  <p className="card-text">Welcome back! Please sign-in to continue.</p>
              </div>
              <form className="card-body" onSubmit={handleSubmit}>
                  <div className="mb-4">
                      <label className="form-label">Email address/Username</label>
                      <input type="text" className="form-control" placeholder="Enter your email address or username" onChange={(e) => setUsername(e.target.value)} />
                  </div>
                  <div className="mb-4">
                      {/*<label className="form-label d-flex justify-content-between">Password <a href="">Forgot password?</a></label>*/}
                      <input type="password" className="form-control" placeholder="Enter your password" onChange={(e) => setPassword(e.target.value)}  />
                  </div>
                  <button className="btn btn-primary btn-sign">Sign In</button>

              </form>
          </div>
      </div>
  );
}

export default Login;
